<template>
  <BreadCrumb class="hidden sm:block" />
  <ShopPage :entry="entry" />
</template>

<script>
import gql from 'graphql-tag';
import { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import ShopPage, { ShopPageFragment } from '@/components/shop/ShopPage';
import { stripLocale } from '@/utils/i18n';
import { useEntryPage } from '@/composables/useEntryPage';
import BreadCrumb from '@/components/layout/BreadCrumb';

export const ShopPageQuery = gql`
  query ShopPageQuery($site: String!, $uri: String!) {
    entry(section: "shop", site: [$site], uri: [$uri]) {
      ...ShopPageFragment
      ...EntryPageFragment
    }

    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }
  ${EntryPageFragment}
  ${ShopPageFragment}
  ${SeomaticFragment}
`;

export default defineNuxtComponent({
  name: 'ShopPageController',

  components: { ShopPage, BreadCrumb },

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const { locale } = useNuxtApp().$i18n;

    const uri = stripLocale(route.path, locale.value);
    const variables = { site: locale.value, uri };
    try {
      const { entry, seomatic } = await $craftRequest(ShopPageQuery, variables);

      return { entry, seomatic };
    } catch (error) {
      console.error(error);
    }
  },

  created() {
    useEntryPage(this.entry, this.seomatic);
  },
});
</script>
